import { checkboxItemAll } from '@/components/shared/checkbox/lib/constants'

export const projectOptionAll = {
  bc_guid: checkboxItemAll,
  bc_name: 'Все'
}

export const enum AccessesTab {
  Accesses = 'accesses',
  Contacts = 'contacts'
}
